import { render, staticRenderFns } from "./Grade10GroupExpectation.vue?vue&type=template&id=ca0478ee&scoped=true&"
import script from "./Grade10GroupExpectation.vue?vue&type=script&lang=js&"
export * from "./Grade10GroupExpectation.vue?vue&type=script&lang=js&"
import style0 from "./Grade10GroupExpectation.vue?vue&type=style&index=0&id=ca0478ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0478ee",
  null
  
)

export default component.exports